import { BecomeMemberDialog } from '@colonist/clientforge';
import { ColonistMembershipType } from '@colonist/types';
import { mountDialogUIReactComponent } from '../ui_platform/mountDialogUIReactComponent.tsx';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../analytics/Analytics.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { ColonistMembershipProduct } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { uiManagerEvents } from '../EntryShared.ts';
const renderBecomeMemberDialog = mountDialogUIReactComponent(BecomeMemberDialog);
export function showBecomeMemberDialog(type, analyticEventValue) {
    const onConfirm = ()=>{
        uiManagerEvents.premiumMembershipCheckAction();
        sendBecomeMemberAnalyticEvent(analyticEventValue);
    };
    const price = UIUtilsEjsVariables.isUserOnDiscord ? ColonistMembershipProduct.getMembershipProduct(ColonistMembershipType.PremiumMonthly).getDefaultPrice() : undefined;
    renderBecomeMemberDialog({
        type: type,
        price: price,
        onConfirm: onConfirm
    });
}
function sendBecomeMemberAnalyticEvent(eventValue) {
    const eventData = {
        type: AnalyticEventType.ABTestClickAnalytics,
        category: AnalyticEventCategory.ABTestClickAnalytics,
        floatValue: eventValue
    };
    void CA.sendAnalyticEvent(eventData);
}
